package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DocumentLibraryListResponse(
    val count: Int? = null,
    val items: List<DocumentResponseDTO>? = null
)

@Serializable
data class DocumentMetricsDTO(
    val total: Int? = null,
    val policies: Int? = null,
    @SerialName("forms_guidelines") val formsGuidelines: Int? = null,
    @SerialName("recently_updated") val recentlyUpdated: Int? = null
)

@Serializable
data class DocumentResponseDTO(
    val id: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("doc_id") val docId: String? = null,
    val title: String? = null,
    val description: String? = null,
    val category: String? = null,
    @SerialName("applicable_to") val applicableTo: String? = null,
    @SerialName("file_id") val fileId: String? = null,
    @SerialName("file_name") val fileName: String? = null,
    @SerialName("file_type") val fileType: String? = null,
    @SerialName("file_size_bytes") val fileSizeBytes: Int? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("created_by_name") val createdByName: String? = null,
    @SerialName("updated_by_name") val updatedByName: String? = null,
    @SerialName("class_target_ids") val classTargetIds: List<String>? = null
)
